// Created by Apiwat
// 23 June 2020
// Copyright OKKAMI

import styled from "styled-components";

const TitleName = styled.div`
font-weight: bold;
`;

const TitleOrder = styled.div`
  color: ${props => props.app_home_color_primary ? props.app_home_color_primary : "gray"};
  font-size: 16px;
`;

const Detail = styled.div`
  color: gray;
`;

const Container = styled.div`
  padding: 0 0 5rem 0;
`;

const Total = styled.div`
  font-size: 12px;
  font-weight: bold;
`;

const Subtotal = styled.div`
  color: gray;
  font-size: 12px;
`;
const Status = styled.div`
  color: gray;
  text-align: end;
`;
const StatusValue = styled.div`
color: ${props => props.app_home_color_primary ? props.app_home_color_primary : "black"};
font-weight: bold;
text-align: end;
`;

const ProductOption = styled.pre`
  color: gray;
  font-family: 'Open Sans','Montserrat',sans-serif;
  word-break: break-word;
  white-space: pre-wrap;
`;

const Notes = styled.pre`
  color: gray;
  font-family: 'Open Sans','Montserrat',sans-serif;
  word-break: break-word;
  white-space: pre-wrap;
  font-size: 12px;
`;

export {
  TitleName,
  TitleOrder,
  Detail,
  Container,
  Total,
  Subtotal,
  ProductOption,
  Status,
  StatusValue,
  Notes
};
